import apiClient from "./api";

export interface Customer {
  id?: number;
  code: string;
  name: string;
  email?: string;
  phone?: string;
  country?: string;
  address?: string;
  status?: number;
  type?: string;
  deposit?: number;
  created_at?: string;
  updated_at?: string;
}

const customerService = {
  async getCustomers(params?: { q?: string; status?: number | string; country?: string }): Promise<Customer[]> {
    const response = await apiClient.get("/customers", { params });
    return response.data.data ?? response.data;
  },
  async getCustomer(id: number): Promise<Customer> {
    const response = await apiClient.get(`/customers/${id}`);
    return response.data.data ?? response.data;
  },
  async createCustomer(input: Omit<Customer, "id">): Promise<Customer> {
    const response = await apiClient.post("/customers", input);
    return response.data.data ?? response.data;
  },
  async updateCustomer(id: number, input: Partial<Omit<Customer, "id">>): Promise<Customer> {
    const response = await apiClient.put(`/customers/${id}`, input);
    return response.data.data ?? response.data;
  },
  async deleteCustomer(id: number): Promise<void> {
    await apiClient.delete(`/customers/${id}`);
  },
  async exportCustomers(ids?: number[]): Promise<Blob> {
    const params: Record<string, string> = {};
    if (ids && ids.length) {
      params.ids = ids.join(",");
    }
    const response = await apiClient.get("/customers/export", {
      params,
      responseType: "blob",
    });
    return response.data as Blob;
  },
  async importCustomers(file: File): Promise<{ success: boolean; imported?: number }> {
    const form = new FormData();
    form.append("file", file);
    const response = await apiClient.post("/customers/import", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data ?? { success: true };
  },
  async addDeposit(id: number, input: { amount: number; paid_by: string; note?: string }): Promise<{ message: string; current_deposit: number }> {
    const response = await apiClient.post(`/customers/${id}/deposit`, input);
    return response.data;
  },
};

export default customerService;
